import pick from 'lodash/pick';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

import flow from 'lodash/fp/flow';
import fMap from 'lodash/fp/map';
import fFind from 'lodash/fp/find';
import fMapKeys from 'lodash/fp/mapKeys';
import fFilter from 'lodash/fp/filter';
import fMerge from 'lodash/fp/merge';
import pipe from 'lodash/fp/pipe';
import groupBy from 'lodash/fp/groupBy';
import values from 'lodash/fp/values';

import { CARS_FIELDS, CARS_FIELDS_MAP } from '../constants';

const pickFieldsFrom = plan => fields => pick(plan, fields);

const mapKeys = map => fMapKeys(key => (map[key] ? map[key] : key));

const hasVrn = ({ VRN }) => !isNil(VRN);

export const getPlanCarsList = plan =>
  flow([
    fMap(pickFieldsFrom(plan)),
    fMap(mapKeys(CARS_FIELDS_MAP)),
    fFilter(hasVrn),
  ])(CARS_FIELDS);

const findCorrespondingDetails = ({ VRN }) =>
  fFind(({ regName }) => regName.toUpperCase() === VRN.toUpperCase());

const extractDetailsFields = ({
  maker: { name: makerName },
  model: { name: modelName },
}) => ({
  makerName,
  modelName,
});

export const mergeCarDetails = carDetailsList => car =>
  flow([findCorrespondingDetails(car), extractDetailsFields, fMerge(car)])(
    carDetailsList,
  );

const pullEmail = ({ User: { email }, ...user }) => ({
  ...user,
  email,
});

const composeAddress = ({ addressLine1, addressLine2, city, ...user }) => ({
  ...user,
  address: [addressLine1, addressLine2, city].filter(a => !isNil(a)).join(', '),
});

export const composeUser = flow(
  pullEmail,
  composeAddress,
);

export const composePlanCommonInfo = ({ Package: { name }, ...plan }) => ({
  ...plan,
  packageName: name,
});

const normalizeColumn = fMap(({ column, ...fields }) => ({
  ...fields,
  column: column || 1,
}));

export const composeColumns = pipe(
  normalizeColumn,
  groupBy('column'),
  values,
);

export const composePlanCancellationDetails = deatails => ({
  ...deatails,
  userEmail: get(deatails, 'User.email'),
});
